import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../services/global';
import { BaseCrudComponent } from '../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';
import { Observable, BehaviorSubject, of, throwError, from } from 'rxjs';
import { mergeMap, catchError, timeout, retry } from 'rxjs/operators';
import { ExportAsService, ExportAsConfig } from 'ngx-export-as';
import * as moment from 'moment-timezone';

import { LazyLoadEvent } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import {MessageService} from 'primeng/api';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-masterroute',
  templateUrl: './masterroute.component.html',
  styleUrls: ['./masterroute.component.css']
})
export class MasterrouteComponent extends BaseCrudComponent {

	exportAsConfig: ExportAsConfig = {
	    type: 'xlsx', // the type you want to download
        //type: 'pdf', // the type you want to download
	    elementIdOrContent: 'exportable', // the id of html/table element
        //elementIdOrContent: 'pdfexport', // the id of html/table element
        /*options: { // html-docx-js document options
            margin:       0.5,
            image:        { type: 'jpeg', quality: 0.99 },
            html2canvas:  { scale: 2 },
            jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
        }*/
	};

	translations:any;
	header:any;
	momentjs: any = moment;
    curr_date:any;
    dstart:any;
    dend:any;
    zones:any;
    //jspdf: any = jsPDFTable;

    offline_key_list = 'MASTER_ROUTE';
    offline_key_zones = 'ZONES';
    offline_date = '';

	constructor(
	    srv: ApiService,
	    modalService: NgbModal,
	    storage: Storage,
  		router: Router,
  		private route: ActivatedRoute,
        public translate: TranslateService,
        private exportAsService: ExportAsService
	  ) {
	    super(srv, modalService, storage, router);
	    this.read_url = 'ReportRouteMaster/Post';
        this.header = {};
        this.zones = [];

        this.srv.offline.subscribe(r => {
            this.isOffline = r;
        });

        //this.isOffline = false;
    }

    ngOnInit() {
        this.dstart = this.momentjs().tz('America/Guayaquil');
        this.dstart.day(1);
        //this.f_datefrom = this.dstart.format('YYYY-MM-DD');
        this.f_datefrom = {year:this.dstart.year(), month:this.dstart.month()+1, day:this.dstart.date()};

        this.dend = this.momentjs().tz('America/Guayaquil');
        this.dend.day(5);
        //this.f_dateto = this.dend.format('YYYY-MM-DD');
        this.f_dateto = {year:this.dend.year(), month:this.dend.month()+1, day:this.dend.date()};

        this.curr_date = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        //this.curr_date = this.momentjs().tz('America/Guayaquil');

    	this.translate.getTranslation(this.translate.currentLang)
        .subscribe((translations) => {
              this.translations = translations;
              super.ngOnInit();
              this.getList();
        });

        this.getZonesData().subscribe(x => {
            if(x != false){
                this.zones = x;
            }
        });
    }

    public getList(){
        var qst = this.read_url;
        var obj:any;
        this.header = {};
        this.rows = [];
        
        var start = this.momentjs(this.getISODate(this.f_datefrom));
        var end = this.momentjs(this.getISODate(this.f_dateto));
        
        if( end.isSameOrBefore(start) ){
            Swal.fire('Fecha Hasta debe ser mayor a Fecha Desde', '', 'error');
            return;
        }

        obj = {
            from: this.getISODate(this.f_datefrom),
            to: this.getISODate(this.f_dateto),
            Zone: null
        }

        if( (this.f_custom1 != null) && (this.f_custom1 != 'null') ){
            obj.Zone = this.f_custom1;
        }

        if(this.isOffline){
            this.srv.getOfflineData(this.offline_key_list).then(x => {
                //console.log(x);
                var rs = x.data;
                if( (rs != null) && (rs != undefined) ){
                    this.header = rs.header;
                    this.parseDetails(rs.detail);
                    this.offline_date = x.last_update;
                }
            });
        }
        else{
            this.loadingList = true;
            this.srv.postCall(qst, obj).subscribe(x => {
                this.loadingList = false;

                if(x.status){
                    var rs = x.data;
                    this.srv.saveOfflineData(this.offline_key_list, rs);
                    this.header = rs.header;
                    this.parseDetails(rs.detail);
                }
            });
        }

    }

    parseDetails(rs:any){
    	this.rows = [];
    	this.rawdata = [];
    	var tmp:any;
    	var tobj:any;
    	
    	rs.forEach(x => {
    		tmp = {day:'', desc:'', items:[]};
    		tobj = this.momentjs(x.day, 'YYYY-MM-DDThh:mm:ss');
    		tmp.day = this.translations[tobj.format('dddd')] + ' [ ' + tobj.format('YYYY-MM-DD') + ' ]';
    		tmp.desc = x.salesGoal;

    		x.items.forEach(i => {
    			let inner = {
    				city: i.ciudad,
    				code: i.zona,
    				client: i.nombreCliente,
    				typo: i.tipologia,
    				abc: i.claseAbc,
                    idCliente: i.idCliente,
                    color: (i.color == 'x')
    			};

    			tmp.items.push(inner);
    		});

    		this.rawdata.push(tmp);
    	});

    	this.rows = this.rawdata;
    }

    public getZonesData(){
        var par_url = 'ZoneBP/ListByUser';

        if(this.isOffline){
            //return of(false);
            return from( this.srv.getOfflineData(this.offline_key_zones).then(x => {
                if( x != null ){
                    return x.data;
                }
                else{
                    return false;
                }
            }) );
        }
        else{
            return this.srv.getCall(par_url).pipe(
                        mergeMap(data => {
                            let mydata:any = {status: false, data: [], message: ''};
                            mydata = data;
                            //console.log(data);
                            
                            if( mydata.status ){
                                this.srv.saveOfflineData(this.offline_key_zones, mydata.data);
                                return of(mydata.data);
                            }
                            else{
                                return of(false);
                            }
                          }),
                          //timeout(MAX_TIME),
                          catchError(data => {return of(false)})
                    );
        }
    }

    getPdfReportHeader(){
        var obj = [];

        obj.push([{content:'MAESTRO RUTA', colSpan:4, styles:{fontStyle:'bold', halign:'center'}}]);
        obj.push([
            {content:'Zona:', colSpan:2},
            {content:'Fecha: ' + this.curr_date, colSpan:2}
        ]);
        obj.push([
            {content:'Vendedor: ' + this.header['agent'], colSpan:2},
            {content:'Desde: ' + this.getISODate(this.f_datefrom), colSpan:2}
        ]);
        obj.push([
            {content:'Supervisor: ' + this.header['supervisor'], colSpan:2},
            {content:'Hasta: ' + this.getISODate(this.f_dateto), colSpan:2}
        ]);

        return obj;
    }

    exportReport(){
    	/*this.exportAsService.save(this.exportAsConfig, 'maestro_ruta'+this.curr_date).subscribe(() => {
	      // save started
	    });*/
        //console.log(this.jspdf.default('p','pt', 'a4'));

        var cols = [
            { dataKey: 'city', title: 'CIUDAD' },
            { dataKey: 'idCliente', title: 'CODIGO' },
            { dataKey: 'client', title: 'CLIENTE' },
            { dataKey: 'typo', title: 'TIPOLOGIA' },
            { dataKey: 'abc', title: 'ABC' }
        ];

        //const doc = new jsPDF.default(0,0);
        //var doc = new jsPDF();
        //let doc = this.jspdf('p','pt', 'a4');
        //let doc = this.jspdf.default('p','pt', 'a4')
        /*let doc = this.jspdf.default(0,0);

        this.rows.forEach(r => {
            doc.autoTable(cols, r.items);
        });

        doc.save('alex_test.pdf');*/

        //const doc = new jsPDF();
        var doc = new jsPDF('p','pt', 'a4');
        autoTable(doc, {body: this.getPdfReportHeader(), theme:'grid'});

        this.rows.forEach(r => {
            let x = [];
            r.items.forEach(i => {
                
                if(i.color){
                    i.bgcolor = '#f9dc7c';
                }
                else{
                    i.bgcolor = '';
                }

                x.push([
                    {content: i.city, styles: {fillColor: i.bgcolor}},
                    {content: i.idCliente, styles: {fillColor: i.bgcolor}},
                    {content: i.client, styles: {fillColor: i.bgcolor}},
                    {content: i.typo, styles: {fillColor: i.bgcolor}},
                    {content: i.abc, styles: {fillColor: i.bgcolor}}
                ]);
            });

            let header = [];
            header.push([{content:'Objetivo: ' + r.desc + ' USD', colSpan:5, styles:{fontStyle:'bold', fillColor:'#fff', textColor:'#000'}}]);
            header.push([{content:r.day, colSpan:5, styles:{fontStyle:'bold', halign:'center'}}]);
            header.push(['CIUDAD', 'CODIGO', 'CLIENTE', 'TIPOLOGIA', 'ABC']);

            //autoTable(doc, {head:[[{content:'CIUDAD', styles:{fillColor: 'yellow'}}, 'CODIGO', 'CLIENTE', 'TIPOLOGIA', 'ABC']], body: x});
            autoTable(doc, {head:header, body: x});
        });
        
        doc = this.addPagesHeaderAndFooter(doc);
        doc.save('maestro_ruta_' + this.getISODate(this.f_datefrom) + '_' + this.getISODate(this.f_dateto));
    }

    addPagesHeaderAndFooter(doc:any) {
        var totalPages = doc.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            doc.addImage(Global.logo_base64, 'PNG', 465, 10, 90, 20);
            /*doc.setTextColor(150);
            doc.text(50, doc.internal.pageSize.height - 30, 'Watermark');*/

            // Footer
            var str = 'Página ' + i + ' de ' + totalPages;
            doc.setFontSize(10);

            // jsPDF 1.4+ uses getWidth, <1.4 uses .width
            var pageSize = doc.internal.pageSize;
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
            doc.text(str, 40, pageHeight - 10);
        }

        return doc;
    }

}
